<template>
  <div class="bb-contact-visas-table-link-cell">
    <div
      class="bb-contact-visas-table-link-cell__container"
    >
      <div class="bb-contact-visas-table-link-cell__text">
        {{link}}
      </div>
      <span
        v-if="!isCopied"
        v-html="linkIcon"
        class="bb-contact-visas-table-link-cell__link"
        @click="$emit('copy')"
      />
      <span
        v-else
        class="bb-contact-visas-table-link-cell__link-copied"
      >
        Link copied
      </span>
    </div>
  </div>

</template>

<script>
import {LinkTwoIcon} from '@/constants/icon'
export default {
  name: "ContactCompanyVisasTableLink",
  props: {
    isCopied: {
      type: Boolean,
      default: false,
    },
    link: {
      type: String,
      default: '',
    }
  },
  data () {
    return {
      linkIcon: LinkTwoIcon(),
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/variables";

.bb-contact-visas-table-link-cell {

  &__container {
    display: flex;
    align-items: center;
    column-gap: 3px;
    padding-right: 25px;
  }

  &__text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: calc(100% - 25px);
  }

  &__link {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: $color-wild-sand;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: $color-denim;
  }

  &__link-copied {
    padding: 6px;
    white-space: nowrap;
    border-radius: 4px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: $color-denim;
    background-color: rgba($color-denim, 0.14);
    font-size: 12px;
    font-weight: 500;
    line-height: 14px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Dissemination/Sales/CRM/ContactCompany/ContactCompanyVisas/ContactCompanyVisasTableLink.vue